import React, { FC } from 'react';

import { ModalInfo } from '@.modal';
import { Button, Checkbox, Input } from '@.ui';
import { DeviceLicenseKeyStatusEnum } from '@/entities/Device/model';
import { createPreventDefault } from '@/Lib';

import S from './styles.module.scss';
import { useEditLicenseKeyHttp } from './useEditLicenseKeyHttp';

type EditLicenseKeyModalProps = {
    deviceId: number;
    licenseKeyStatus?: DeviceLicenseKeyStatusEnum | null;
    licenseKeyInitial: string;
    updateDevice: (deviceId: number, licenseKey: string) => void;
};

export const EditLicenseKeyHttpModal: FC<EditLicenseKeyModalProps> = ({ deviceId, licenseKeyStatus, licenseKeyInitial, updateDevice }) => {
    const { isLoading, close, field, requestSaveLicenseKey } = useEditLicenseKeyHttp({
        deviceId,
        licenseKeyInitial,
        updateDevice,
    });

    const ModalContentData = (
        <div className={S.edit_license_key_modal}>
            <h1 className={S.edit_license_key_modal__title}>
                <span>Edit license key</span>
                <span className={S.edit_license_key_modal__title__status}>By HTTP</span>
            </h1>
            <Input {...field('licenseKey').register()} required text={'License key'} />

            <Checkbox
                {...field('isForcedPending').register()}
                className={S.edit_license_key_modal__checkbox}
                isDisabled={licenseKeyStatus !== DeviceLicenseKeyStatusEnum.ERROR}
                text="Mark license key as pending for automatic update on 2000p"
            />

            <div className={S.edit_license_key_modal_actions}>
                <Button color="brown" disabled={isLoading} onClick={requestSaveLicenseKey}>
                    Save
                </Button>

                <Button onClick={createPreventDefault(close)}>Cancel</Button>
            </div>
        </div>
    );

    return <ModalInfo children={ModalContentData} />;
};
